import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { RecipientType } from '@40seas/entities/notifications';
import { z } from 'zod';

export const BusinessEmailRecipientsProviderPayloadSchema = z.object({
    type: EnumSchema(RecipientType),
});

export class BusinessEmailRecipientsProviderPayload extends FromSchema(BusinessEmailRecipientsProviderPayloadSchema) {
    type: RecipientType; // Primary/Secondary for output recipent types
}
